import React, { useEffect, useState } from "react";
import { Button, Spin, message, Tag } from "antd";
import aiConsoleService from "services/aiconsoleservice";

const Row = ({ label, children }) => (
  <div className="flex justify-between gap-4 py-2 border-b border-gray-100 dark:border-gray-700 last:border-0">
    <span className="text-gray-500 dark:text-gray-400">{label}</span>
    <span className="text-slate-800 dark:text-white text-right break-all">{children}</span>
  </div>
);

const Settings = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [recompiling, setRecompiling] = useState(false);

  const load = () => {
    setLoading(true);
    aiConsoleService
      .getSettings()
      .then((res) => {
        setData(res);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(load, []);

  const recompile = async () => {
    setRecompiling(true);
    try {
      const res = await aiConsoleService.recompileKb();
      message.success(`Knowledge base recompiled (${res?.compiled ?? 0} sections).`);
      load();
    } catch (e) {
      message.error("Recompile failed.");
    } finally {
      setRecompiling(false);
    }
  };

  if (loading) return <div className="p-8 flex justify-center"><Spin /></div>;
  if (!data) return <div className="p-8 text-center text-gray-400">No data.</div>;

  return (
    <div className="max-w-2xl space-y-4">
      <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-4">
        <Row label="Model"><span className="text-xs">{data.model}</span></Row>
        <Row label="Chat mode">
          {data.chat_readonly ? <Tag color="blue">Read-only</Tag> : <Tag color="orange">Read / Write</Tag>}
        </Row>
        <Row label="KB sections">{data.kb?.sections ?? 0}</Row>
        <Row label="KB last compiled">{data.kb?.last_compiled_at ?? "never"}</Row>
      </div>
      <Button type="primary" loading={recompiling} onClick={recompile}>
        Recompile KB
      </Button>
    </div>
  );
};

export default Settings;
